import { CountryProvider } from "component_library/contexts/countryContext"
import React from "react"
import { EntityContextProvider } from "./entityContext"
import { UserContextProvider, type User } from "./userContext"
import { CountryCode, EntityType } from "DealerApp/lib/scalars"

interface DealerAppContextsProviderProps {
  children: React.ReactNode
  country: CountryCode
  entityType: EntityType
  entityId: string
  user: User
}

const DealerAppContextsProvider = ({
  children,
  country,
  entityType,
  entityId,
  user,
}: DealerAppContextsProviderProps) => {
  return (
    <EntityContextProvider value={{ type: entityType, id: entityId }}>
      <CountryProvider value={country}>
        <UserContextProvider value={user}>{children}</UserContextProvider>
      </CountryProvider>
    </EntityContextProvider>
  )
}

export default DealerAppContextsProvider
